module.exports = __webpack_public_path__ + "assets/img/ykzx-select.260f4f50.png";